import React, { Component } from 'react';
import Switch from 'react-switch';
import './PopupTitleBar.css';

export default class PopupTitleBar extends Component {
  constructor(props) {
    super(props);

    let mode = this.props.mode;
    this.state = {
        mode
    };
  }
  closePopupHandler = () => {
    this.props.closePopup();
  }
  handleModeChange = (checked) => {
    this.props.handleModeChange(checked?"full":"simple");
    this.setState({ mode: checked?"full":"simple" });
  }
  render() {
    return (
        <div className="PopupTitleBar">
          {/* { this.props.mode &&
            <div className="PopupTitleBar-Toggle">
                <Switch
                    checked={this.state.mode==="full"}
                    onChange={this.handleModeChange}
                    height={18}
                    width={64}
                    onColor="#E60935"
                    offColor="#03CA23"
                    uncheckedIcon={
                        <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 10,
                            color: "white",
                            paddingRight: 25
                        }}
                        >
                        SIMPLE
                        </div>
                    }
                    checkedIcon={
                        <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 10,
                            color: "white",
                            paddingLeft: 20
                        }}
                        >
                        FULL
                        </div>
                    }
                    className="react-switch"
                    id="icon-switch"
                    />
            </div>
          } */}
            <div className="PopupTitleBar-Name">{this.props.title}</div>
            <div className="PopupTitleBar-Close" onClick={this.closePopupHandler}>+</div>
        </div>
    );
  }
}